<template>
  <div class="box my-background">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
    <h1 class="subtitle has-text-weight-bold">
      {{ title }}
    </h1>

    <Resurs
      v-for="resurs in resursi"
      :key="resurs.id"
      :resurs="resurs"
      :izmenaDozvoljena="false"
      :tekstVidljiv="false"
    ></Resurs>
  </div>
</template>

<script>
//import { mapState } from 'vuex'
import Resurs from '../components/Resurs'
import ResursService from '@/services/ResursService'

export default {
  components: {
    Resurs
  },
  props: {
    type: String,
    title: String,
    count: String
  },
  data() {
    return {
      resursi: [],
      isLoading: false
    }
  },
  created() {
    this.perPage = 3 // Setting perPage here and not in data means it won't be reactive.
    // We don't need it to be reactive, and this way our component has access to it.

    // this.$store.dispatch('resursi/dajResurse', {
    //   type: this.type,
    //   perPage: this.count, // poslednje 4 vesti
    //   page: 1,
    //   filters: {}
    // })

    this.isLoading = true
    // this.isLoading = false
    ResursService.dajResurse(this.type, this.count, 1, {}).then(response => {
      this.isLoading = false
      this.resursi = response.data.podaci
    })
  },
  computed: {
    //...mapState('resursi', ['resursi'])
  }
}
</script>

<style scoped>
.right {
  /* background: green; */
  /* height: 100%; */
  overflow: auto;
}

.my-background {
  background-color: whitesmoke;
}
</style>
